export const DAILY_QUIZ = [
    {
        "question": "What is the main difference between roguelike and roguelite?",
        "possibilities": [
            "Roguelite keeps permanent upgrades",
            "Roguelike is harder",
            "Roguelite has better graphics",
            "There is no difference"
        ],
        "answer": 0
    },
    {
        "question": "A boy explores an island solving line-based puzzles.",
        "possibilities": [
            "The Witness",
            "Myst",
            "Obduction",
            "The Talos Principle"
        ],
        "answer": 0
    },
    {
        "question": "Which genre uses cards for player actions?",
        "possibilities": [
            "Deckbuilding",
            "RTS",
            "MOBA",
            "Battle Royale"
        ],
        "answer": 0
    },
    {
        "question": "Which studio is behind Bastion, Transistor, and Hades?",
        "possibilities": [
            "Supergiant Games",
            "Team Cherry",
            "Subset Games",
            "Klei"
        ],
        "answer": 0
    },
    {
        "question": "A beetle must save the kingdom of Hallownest from infection.",
        "possibilities": [
            "Hollow Knight",
            "Bug Fables",
            "Grounded",
            "The Centennial Case"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a fox solving riddles in ruins?",
        "possibilities": [
            "Tunic",
            "The First Tree",
            "Spirit of the North",
            "RiME"
        ],
        "answer": 0
    },
    {
        "question": "Which boss-rush game has you face colossal titans with one arrow?",
        "possibilities": [
            "Titan Souls",
            "Furi",
            "Jotun",
            "Shadow of the Colossus"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Crow' harvesting souls?",
        "possibilities": [
            "Death's Door",
            "Ravenlok",
            "Crowsworn",
            "Never Raven"
        ],
        "answer": 0
    },
    {
        "question": "Which of these titles was developed by an indie studio?",
        "possibilities": [
            "Cuphead",
            "Overwatch",
            "Hearthstone",
            "Valorant"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is 'Minesweeper' mixed with 'RPG'?",
        "possibilities": [
            "Demon Crawl",
            "Mamono Slayer",
            "Runestone Keeper",
            "Dungelot"
        ],
        "answer": 0
    },
    {
        "question": "Among these fighting games, which is indie?",
        "possibilities": [
            "Skullgirls",
            "Tekken 8",
            "Street Fighter 6",
            "Mortal Kombat 1"
        ],
        "answer": 0
    },
    {
        "question": "Which indie sparked a controversy about game engines in 2023 (Unity)?",
        "possibilities": [
            "Cult of the Lamb",
            "Slay the Spire",
            "Silksong",
            "Rust"
        ],
        "answer": 0
    },
    {
        "question": "What object does the main character collect in A Hat in Time?",
        "possibilities": [
            "Time Pieces",
            "Stars",
            "Coins",
            "Hats"
        ],
        "answer": 0
    },
    {
        "question": "What does 'Pixel Art' mean?",
        "possibilities": [
            "Visible pixel graphics",
            "Ultra-realistic",
            "Claymation",
            "Comic style"
        ],
        "answer": 0
    },
    {
        "question": "Which indie mixes 'Tetris' and 'Dungeon RPG'?",
        "possibilities": [
            "Loot River",
            "Pocket Dungeon",
            "Swap Fire",
            "Tetris Effect"
        ],
        "answer": 1
    },
    {
        "question": "Which indie game is played with only two buttons (left/right) to fight?",
        "possibilities": [
            "One Finger Death Punch",
            "Divekick",
            "Nidhogg",
            "Karateka"
        ],
        "answer": 0
    },
    {
        "question": "Among these adventure games, which is indie?",
        "possibilities": [
            "Tunic",
            "Uncharted 4",
            "Tomb Raider",
            "Horizon"
        ],
        "answer": 0
    },
    {
        "question": "Which roguelike card game is famous for its dark, sacrificial mechanics?",
        "possibilities": [
            "Inscryption",
            "Slay the Spire",
            "Monster Train",
            "Roguebook"
        ],
        "answer": 0
    },
    {
        "question": "In which game do you relive a 12-minute loop to prevent a murder?",
        "possibilities": [
            "Twelve Minutes",
            "Time Loop",
            "Time Handlers",
            "Nine Minutes"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a sushi restaurant?",
        "possibilities": [
            "Sushi Bar",
            "Cook Serve Delicious",
            "Good Pizza Great Pizza",
            "Diner Dash"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is about 'organizing tools' in a box?",
        "possibilities": [
            "A Little to the Left",
            "Unpacking",
            "Warehouse",
            "Organizing Game"
        ],
        "answer": 0
    },
    {
        "question": "A red robot travels through colorful levels carrying a television.",
        "possibilities": [
            "Unbox",
            "Journey",
            "Abzu",
            "Flower"
        ],
        "answer": 0
    },
    {
        "question": "In 'Hotline Miami', what does the protagonist wear on his face?",
        "possibilities": [
            "Animal masks",
            "Motorcycle helmet",
            "Surgical mask",
            "Nothing"
        ],
        "answer": 0
    },
    {
        "question": "In 'Balatro', what items provide major passive bonuses?",
        "possibilities": [
            "Joker cards",
            "Tarot cards",
            "Planets",
            "Vouchers"
        ],
        "answer": 0
    },
    {
        "question": "Among these sports games, which is indie?",
        "possibilities": [
            "Rollerdrome",
            "FIFA",
            "NBA 2K",
            "Madden"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a journalist investigating a murder in a real-time clock?",
        "possibilities": [
            "The Occupation",
            "L.A. Noire",
            "Murdered: Soul Suspect",
            "The Vanishing of Ethan Carter"
        ],
        "answer": 0
    },
    {
        "question": "Which indie studio bought back its rights from Ubisoft to become independent again?",
        "possibilities": [
            "IO Interactive",
            "Bungie",
            "Gearbox",
            "Remedy"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Fox' in a cyberpunk future?",
        "possibilities": [
            "Neon Node",
            "Laika",
            "Stray",
            "Tunic"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Bullet Hell'?",
        "possibilities": [
            "Screen filled with projectiles",
            "Cooking game",
            "Golf game",
            "Rhythm game"
        ],
        "answer": 0
    },
    {
        "question": "Which game is considered the 'father' of the Roguelike Deckbuilder?",
        "possibilities": [
            "Slay the Spire",
            "Dream Quest",
            "Monster Train",
            "Hand of Fate"
        ],
        "answer": 0
    },
    {
        "question": "What does 'Permadeath' mean?",
        "possibilities": [
            "Permanent character death",
            "Infinite respawn",
            "Invincibility",
            "Endless game"
        ],
        "answer": 0
    },
    {
        "question": "In which game do you play a lamb guru building a cult?",
        "possibilities": [
            "Cult of the Lamb",
            "Lamb Cult",
            "Hades",
            "The Black Lamb"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play as a 'Rock' rolling through history?",
        "possibilities": [
            "Rock of Ages",
            "Rolling Hell",
            "Polyball",
            "Ballance"
        ],
        "answer": 0
    },
    {
        "question": "In 'Inside', what color is the boy's t-shirt?",
        "possibilities": [
            "Red",
            "Blue",
            "Yellow",
            "White"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game has a script over 1 million words long?",
        "possibilities": [
            "Disco Elysium",
            "Baldur's Gate 3",
            "Undertale",
            "Sea of Stars"
        ],
        "answer": 0
    },
    {
        "question": "Which boxing/rhythm hybrid is indie?",
        "possibilities": [
            "Thunder Ray",
            "Super Punch-Out!!",
            "Knockout City",
            "Fitness Boxing"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a wolf exploring the wilderness?",
        "possibilities": [
            "WolfQuest",
            "Lost Ember",
            "Spirit of the North",
            "The First Tree"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game simulates being a blacksmith?",
        "possibilities": [
            "Jacksmith",
            "Potion Craft",
            "Potionomics",
            "Blacksmith Sim"
        ],
        "answer": 0
    },
    {
        "question": "Which indie studio created 'Among Us'?",
        "possibilities": [
            "Innersloth",
            "LocalThunk",
            "Landfall",
            "Poncle"
        ],
        "answer": 0
    },
    {
        "question": "Which strategy game is indie?",
        "possibilities": [
            "Into the Breach",
            "StarCraft II",
            "Age of Empires IV",
            "Total War"
        ],
        "answer": 0
    },
    {
        "question": "Astronauts explore colorful planets collecting resources.",
        "possibilities": [
            "Astroneer",
            "No Man's Sky",
            "Starbound",
            "Terraria"
        ],
        "answer": 0
    },
    {
        "question": "What gameplay mechanic makes Hades unique among roguelikes?",
        "possibilities": [
            "Each death advances the story",
            "You cannot die",
            "The game gets easier",
            "Enemies are random"
        ],
        "answer": 0
    },
    {
        "question": "A boy and his dog cross a dangerous world in a black and white game.",
        "possibilities": [
            "Limbo",
            "Inside",
            "Little Nightmares",
            "Somber"
        ],
        "answer": 0
    },
    {
        "question": "Medieval heroes face bosses in a stylized combat game.",
        "possibilities": [
            "Furi",
            "Titan Souls",
            "Eldest Souls",
            "Jotun"
        ],
        "answer": 0
    },
    {
        "question": "Which game created the 'Auto-Battler' genre?",
        "possibilities": [
            "Dota Auto Chess (Mod)",
            "Vampire Survivors",
            "Backpack Hero",
            "Teamfight Tactics"
        ],
        "answer": 0
    },
    {
        "question": "Among these 'Cleaning' games, which is indie?",
        "possibilities": [
            "Viscera Cleanup Detail",
            "PowerWash Sim",
            "House Flipper",
            "Crime Scene Cleaner"
        ],
        "answer": 0
    },
    {
        "question": "Cute creatures grow plants and explore caves.",
        "possibilities": [
            "Ooblets",
            "Slime Rancher",
            "Garden Paws",
            "Yonder"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you explore space stations via drones and command lines?",
        "possibilities": [
            "Duskers",
            "Observation",
            "Event[0]",
            "Tin Can"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie has you play a ghost possessing objects?",
        "possibilities": [
            "Hauntii",
            "Selaco",
            "Animal Well",
            "Crow Country"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a samurai fighting in a neon 2D world?",
        "possibilities": [
            "Katana ZERO",
            "Ghost of Tsushima",
            "Nioh",
            "Sekiro"
        ],
        "answer": 0
    },
    {
        "question": "Which indie cooking game is known for stressful co-op?",
        "possibilities": [
            "Overcooked",
            "Battle Chef Brigade",
            "PlateUp!",
            "Cook Serve Delicious"
        ],
        "answer": 0
    },
    {
        "question": "A robot explores levels using portals (Indie clone style).",
        "possibilities": [
            "Quantum Conundrum",
            "Portal",
            "The Turing Test",
            "Lightmatter"
        ],
        "answer": 0
    },
    {
        "question": "In 'Hades', who is the father of the protagonist Zagreus?",
        "possibilities": [
            "Hades",
            "Zeus",
            "Poseidon",
            "Ares"
        ],
        "answer": 0
    },
    {
        "question": "Which tactical RPG is indie?",
        "possibilities": [
            "Wartales",
            "Fire Emblem",
            "Tactics Ogre",
            "Baldur's Gate 3"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie is a horror FPS inside a car?",
        "possibilities": [
            "Pacific Drive",
            "Beware",
            "Iron Lung",
            "Road 96"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is famous for 'Twitch Integration'?",
        "possibilities": [
            "Cult of the Lamb",
            "Choice Chamber",
            "Dead Cells",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "A platformer that takes place inside the memories of an old man.",
        "possibilities": [
            "Old Man's Journey",
            "The Gardens Between",
            "To the Moon",
            "A Bird Story"
        ],
        "answer": 0
    },
    {
        "question": "What are characters looking for in Enter the Gungeon?",
        "possibilities": [
            "A gun that can kill the past",
            "A legendary treasure",
            "An exit",
            "Their memory"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play a detective solving their own murder via reincarnation?",
        "possibilities": [
            "Paradise Killer",
            "The Forgotten City",
            "Return of the Obra Dinn",
            "Her Story"
        ],
        "answer": 0
    },
    {
        "question": "Which survival game has you manage the extreme cold of a storm?",
        "possibilities": [
            "Frostpunk",
            "The Long Dark",
            "Icarus",
            "Whiteout Survival"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a prehistoric zoo with dinosaurs?",
        "possibilities": [
            "Parkasaurus",
            "Prehistoric Kingdom",
            "Jurassic World Evolution",
            "Zoo Tycoon"
        ],
        "answer": 0
    },
    {
        "question": "In 'The Binding of Isaac', who is the boss of Chapter 1 usually?",
        "possibilities": [
            "Monstro",
            "Mom",
            "Duke of Flies",
            "Larry Jr."
        ],
        "answer": 0
    },
    {
        "question": "Which indie game holds the record for most concurrent players on Steam (over 2 million)?",
        "possibilities": [
            "Palworld",
            "Among Us",
            "Valheim",
            "PUBG"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game has you solve riddles by manipulating gravity?",
        "possibilities": [
            "VVVVVV",
            "Gravity Ghost",
            "And Yet It Moves",
            "Gravitas"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game has you hack systems in a cyberpunk future?",
        "possibilities": [
            "Hacknet",
            "Uplink",
            "Quadrilateral Cowboy",
            "Else Heart.Break()"
        ],
        "answer": 0
    },
    {
        "question": "How many people developed Stardew Valley?",
        "possibilities": [
            "One person (Eric Barone)",
            "Two people",
            "A small team of 5",
            "A studio of 20"
        ],
        "answer": 0
    },
    {
        "question": "Adventurers explore dungeons with a first-person view.",
        "possibilities": [
            "Legend of Grimrock",
            "Vaporum",
            "Operencia",
            "Might and Magic X"
        ],
        "answer": 0
    },
    {
        "question": "What is the name of the kingdom where Hollow Knight takes place?",
        "possibilities": [
            "Hallownest",
            "Deepnest",
            "Hollowkingdom",
            "Bugnest"
        ],
        "answer": 0
    },
    {
        "question": "Which 'color-named' indie game does NOT exist as a major title?",
        "possibilities": [
            "Red (Rouge)",
            "Gris",
            "White (Blanc)",
            "Yellow (Jaune)"
        ],
        "answer": 0
    },
    {
        "question": "Which racing game has you pilot futuristic ships at high speed?",
        "possibilities": [
            "Redout",
            "Ballistic NG",
            "GRIP",
            "Distance"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a space station with oxygen and food needs?",
        "possibilities": [
            "Oxygen Not Included",
            "Space Haven",
            "RimWorld",
            "Dwarf Fortress"
        ],
        "answer": 0
    },
    {
        "question": "A spaceship explores planets in a solar system stuck in a time loop.",
        "possibilities": [
            "Outer Wilds",
            "No Man's Sky",
            "Astroneer",
            "Elite Dangerous"
        ],
        "answer": 0
    },
    {
        "question": "In 'Untitled Goose Game', what is the first task?",
        "possibilities": [
            "Get into the garden",
            "Steal keys",
            "Have a picnic",
            "Wet the gardener"
        ],
        "answer": 0
    },
    {
        "question": "Which Steam festival allows you to test hundreds of indie demos?",
        "possibilities": [
            "Steam Next Fest",
            "Summer Sale",
            "Indie World",
            "Gamescom"
        ],
        "answer": 0
    },
    {
        "question": "Which pixel-art game is indie?",
        "possibilities": [
            "Eastward",
            "Octopath Traveler",
            "Triangle Strategy",
            "Live A Live"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game is indie?",
        "possibilities": [
            "The Witness",
            "Portal 2",
            "Super Mario Wonder",
            "Tetris Effect"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Little Cloud' ruining days?",
        "possibilities": [
            "Rain on Your Parade",
            "Cloudpunk",
            "Flower",
            "Weather Lord"
        ],
        "answer": 0
    },
    {
        "question": "How many seasons are there in a year of Stardew Valley?",
        "possibilities": [
            "4",
            "3",
            "5",
            "12"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: In 'Lethal Company', what is your job?",
        "possibilities": [
            "Scrap metal collector",
            "Monster hunter",
            "Space explorer",
            "Ship builder"
        ],
        "answer": 0
    },
    {
        "question": "Among these fighting/boxing games, which is indie?",
        "possibilities": [
            "Punch Club",
            "UFC 5",
            "Fight Night",
            "Undisputed"
        ],
        "answer": 0
    },
    {
        "question": "Which bike game is indie?",
        "possibilities": [
            "Descenders",
            "Lonely Mountains",
            "Riders Republic",
            "Tour de France"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game won 'Game of the Year' at the 2021 Game Awards?",
        "possibilities": [
            "It Takes Two",
            "Hades",
            "Celeste",
            "Journey"
        ],
        "answer": 0
    },
    {
        "question": "Which survival indie reached 1 million sales in just one week in 2021?",
        "possibilities": [
            "Valheim",
            "Raft",
            "Rust",
            "The Forest"
        ],
        "answer": 0
    },
    {
        "question": "In 'Hollow Knight', what is the name of the surface town hub?",
        "possibilities": [
            "Dirtmouth",
            "Hallownest",
            "Deepnest",
            "City of Tears"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a 'Video Game Store Vendor' sim?",
        "possibilities": [
            "Game Store Simulator",
            "Game Dev Tycoon",
            "Shoppe Keep",
            "Game Dev Story"
        ],
        "answer": 0
    },
    {
        "question": "What is the name of the open-source engine used for 'Cassette Beasts'?",
        "possibilities": [
            "Godot",
            "Unity",
            "GZDoom",
            "Ren'Py"
        ],
        "answer": 0
    },
    {
        "question": "How many different 'endings' are in Stanley Parable: Ultra Deluxe?",
        "possibilities": [
            "Over 40",
            "10",
            "5",
            "100"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game has you connect pipes to power machines?",
        "possibilities": [
            "Infinifactory",
            "Opus Magnum",
            "SpaceChem",
            "Pipe Dream"
        ],
        "answer": 0
    },
    {
        "question": "Which shooting game has you fight robots with improvised weapons?",
        "possibilities": [
            "Generation Zero",
            "Roboquest",
            "Risk of Rain 2",
            "Gunfire Reborn"
        ],
        "answer": 0
    },
    {
        "question": "A child explores a dream world made of crayons and drawings.",
        "possibilities": [
            "Crayon Physics",
            "Drawn to Life",
            "Max and the Magic Marker",
            "Scribblenauts"
        ],
        "answer": 0
    },
    {
        "question": "Which platformer has you play as a pink blob that can transform?",
        "possibilities": [
            "Slime-san",
            "Tales of the Neon Sea",
            "Gish",
            "Kirby"
        ],
        "answer": 0
    },
    {
        "question": "Which indie features an 'Amazing Frog'?",
        "possibilities": [
            "Amazing Frog?",
            "Rain World",
            "I Am Fish",
            "Goat Simulator"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Skeleton' saving his king?",
        "possibilities": [
            "Skul: The Hero Slayer",
            "Skeletal Avenger",
            "Pumpkin Jack",
            "Medievil"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was the first major hit on the Wii Shop Channel?",
        "possibilities": [
            "World of Goo",
            "Cave Story",
            "Super Meat Boy",
            "Machinarium"
        ],
        "answer": 0
    },
    {
        "question": "Which game is often considered the first indie game or the first 'Rogue'?",
        "possibilities": [
            "Rogue",
            "Metroid",
            "Pacman",
            "Unreal Engine"
        ],
        "answer": 0
    },
    {
        "question": "Robots explore ruins solving mechanical riddles.",
        "possibilities": [
            "The Turing Test",
            "Portal",
            "QUBE",
            "The Talos Principle"
        ],
        "answer": 0
    },
    {
        "question": "Which platformer has you manipulate time to solve puzzles?",
        "possibilities": [
            "Braid",
            "The Messenger",
            "Katana ZERO",
            "Super Time Force"
        ],
        "answer": 0
    },
    {
        "question": "Which construction game has you manage a colony of survivors on a hostile planet?",
        "possibilities": [
            "RimWorld",
            "Oxygen Not Included",
            "Frostpunk",
            "Surviving Mars"
        ],
        "answer": 0
    },
    {
        "question": "What is the main mechanic of the game Braid?",
        "possibilities": [
            "Time manipulation",
            "Teleportation",
            "Cloning",
            "Invisibility"
        ],
        "answer": 0
    },
    {
        "question": "Which platform gives 88% revenue to indie devs compared to Steam's 70%?",
        "possibilities": [
            "Epic Games Store",
            "GOG",
            "Itch.io",
            "Microsoft Store"
        ],
        "answer": 0
    },
    {
        "question": "Hunters track monsters in a Victorian city with RPG elements.",
        "possibilities": [
            "Salt and Sanctuary",
            "Bloodborne",
            "Bloodstained",
            "Blasphemous"
        ],
        "answer": 0
    },
    {
        "question": "Futuristic soldiers fight in customizable mechs.",
        "possibilities": [
            "Brigador",
            "Strike Vector",
            "Brigador: Up-Armored Edition",
            "Hawken"
        ],
        "answer": 0
    },
    {
        "question": "Which 2023 indie is a 2D 'Firefighting' sim?",
        "possibilities": [
            "Nuclear Blaze",
            "Firegirl",
            "Flame in the Flood",
            "Embr"
        ],
        "answer": 0
    },
    {
        "question": "A child flees a dystopian underwater facility with telepathic powers.",
        "possibilities": [
            "Inside",
            "Limbo",
            "Little Nightmares",
            "Somber"
        ],
        "answer": 0
    },
    {
        "question": "What percentage of Steam revenue is generated by the top 1% of games?",
        "possibilities": [
            "Over 90%",
            "50%",
            "10%",
            "25%"
        ],
        "answer": 0
    },
    {
        "question": "A small robot must rescue his girlfriend and stop a bomb in a hand-drawn mechanical city.",
        "possibilities": [
            "Machinarium",
            "Chibi-Robo",
            "Astro Bot",
            "WALL-E (Not Indie - Error)"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a malicious goose?",
        "possibilities": [
            "Untitled Goose Game",
            "Goat Simulator",
            "I Am Fish",
            "Bee Simulator"
        ],
        "answer": 0
    },
    {
        "question": "What does 'Hidden Object Game' mean?",
        "possibilities": [
            "Finding objects in an image",
            "Stealth game",
            "Shooting game",
            "Racing"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game has you play as a flower traveling on the wind?",
        "possibilities": [
            "Flower",
            "Journey",
            "Abzu",
            "Gris"
        ],
        "answer": 0
    },
    {
        "question": "Among these RPGs, which is indie?",
        "possibilities": [
            "Sea of Stars",
            "Final Fantasy XVI",
            "Dragon Age",
            "Starfield"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a 'skateboarding game with birds'?",
        "possibilities": [
            "SkateBIRD",
            "OlliOlli",
            "Tanuki Sunset",
            "Birdie Wing"
        ],
        "answer": 0
    },
    {
        "question": "A boy and his sister flee an empire chasing them.",
        "possibilities": [
            "A Plague Tale",
            "Brothers: A Tale of Two Sons",
            "Ico",
            "The Last Guardian"
        ],
        "answer": 0
    },
    {
        "question": "In 'Darkest Dungeon', what is the most dangerous element for heroes?",
        "possibilities": [
            "Stress",
            "Monsters",
            "Hunger",
            "Traps"
        ],
        "answer": 0
    },
    {
        "question": "Which management game has you run a video game company?",
        "possibilities": [
            "Game Dev Tycoon",
            "Game Dev Story",
            "Mad Games Tycoon",
            "Software Inc"
        ],
        "answer": 0
    },
    {
        "question": "In 'Dave the Diver', who is the gadget scientist?",
        "possibilities": [
            "Duff",
            "Cobra",
            "Bacon",
            "Bancho"
        ],
        "answer": 0
    },
    {
        "question": "A child builds Lego structures to solve puzzles.",
        "possibilities": [
            "LEGO Builder's Journey",
            "LEGO Worlds",
            "Minecraft",
            "Trailmakers"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a 'boxing RPG' with Game Boy graphics?",
        "possibilities": [
            "World of Horror",
            "Punch Club",
            "Pocket Bravery",
            "Knockout"
        ],
        "answer": 0
    },
    {
        "question": "Which indie uses only sound waves to visualize the world?",
        "possibilities": [
            "Dark Echo",
            "Scanner Sombre",
            "Perception",
            "Beyond Eyes"
        ],
        "answer": 0
    },
    {
        "question": "In 'Pacific Drive', what is your only companion?",
        "possibilities": [
            "Your station wagon",
            "A dog",
            "A robot",
            "An AI"
        ],
        "answer": 0
    },
    {
        "question": "Which indie uses rotoscoping for fluid combat?",
        "possibilities": [
            "The Banner Saga",
            "Cuphead",
            "Dead Cells",
            "Prince of Persia"
        ],
        "answer": 0
    },
    {
        "question": "Which of these is a French indie game?",
        "possibilities": [
            "Chants of Sennaar",
            "Beyond Good & Evil",
            "Rayman",
            "Ghost Recon"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was developed by just 2 brothers (Studio MDHR)?",
        "possibilities": [
            "Cuphead",
            "Ori",
            "Limbo",
            "Inside"
        ],
        "answer": 0
    },
    {
        "question": "In 'Valheim', what is the name of the first boss (Deer)?",
        "possibilities": [
            "Eikthyr",
            "The Elder",
            "Bonemass",
            "Moder"
        ],
        "answer": 0
    },
    {
        "question": "What was the approximate budget of 'Hollow Knight' via its Kickstarter?",
        "possibilities": [
            "$57,000 AU",
            "$1M",
            "$500,000",
            "$10,000"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a ghost haunting a house?",
        "possibilities": [
            "Haunt the House",
            "Ghost Master",
            "Haunted House",
            "Geist"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you manage a 'Cthulhu' cult?",
        "possibilities": [
            "Worshippers of Cthulhu",
            "Cult of the Lamb",
            "Sea Salt",
            "Iratus"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game became a viral phenomenon in 2020 featuring impostors?",
        "possibilities": [
            "Among Us",
            "Fall Guys",
            "Phasmophobia",
            "Valheim"
        ],
        "answer": 0
    },
    {
        "question": "Which indie creator made 'Exploding Kittens'?",
        "possibilities": [
            "The Oatmeal",
            "Baba Is You",
            "Castle Crashers",
            "BattleBlock"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie has you find 8 anomalies in a hallway?",
        "possibilities": [
            "The Exit 8",
            "Shinkansen 0",
            "Platform 8",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which FPS only moves when you move?",
        "possibilities": [
            "SUPERHOT",
            "Ghostrunner",
            "Neon White",
            "Dusk"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a rhythm game fighting in hell?",
        "possibilities": [
            "Metal: Hellsinger",
            "BPM",
            "Thumper",
            "Sayonara Wild Hearts"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: In 'Dave the Diver', what does Dave do at night?",
        "possibilities": [
            "Manages a sushi restaurant",
            "Sleeps",
            "Goes clubbing",
            "Repairs boat"
        ],
        "answer": 0
    },
    {
        "question": "Which of these stealth games is indie?",
        "possibilities": [
            "Gloomwood",
            "Hitman 3",
            "Metal Gear V",
            "Splinter Cell"
        ],
        "answer": 0
    },
    {
        "question": "Which 11 bit studios game preceded Frostpunk?",
        "possibilities": [
            "This War of Mine",
            "Anomaly",
            "Moonlighter",
            "Children of Morta"
        ],
        "answer": 0
    },
    {
        "question": "Which 2023 indie has you climb a giant tower with a small creature?",
        "possibilities": [
            "Jusant",
            "Chants of Sennaar",
            "Cocoon",
            "Viewfinder"
        ],
        "answer": 0
    },
    {
        "question": "Which 'Indie' label actually belongs to Devolver Digital?",
        "possibilities": [
            "It is independent itself",
            "EA Originals",
            "Private Division",
            "Spotlight"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Rhythm Game'?",
        "possibilities": [
            "Action based on music",
            "Puzzle game",
            "Car game",
            "Chess"
        ],
        "answer": 0
    },
    {
        "question": "Which genre is 'Slay the Spire'?",
        "possibilities": [
            "Roguelike Deckbuilder",
            "FPS",
            "Sports",
            "Horror"
        ],
        "answer": 0
    },
    {
        "question": "A photographer explores an abandoned island taking pictures.",
        "possibilities": [
            "Firewatch",
            "Everybody's Gone to the Rapture",
            "What Remains of Edith Finch",
            "Kona"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a 'Border Patrol' sim in a totalitarian state?",
        "possibilities": [
            "Contraband Police",
            "Papers Please",
            "Black Border",
            "Border Officer"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Baby' in a horror house?",
        "possibilities": [
            "Among the Sleep",
            "Lucius",
            "Little Nightmares",
            "Tattletail"
        ],
        "answer": 0
    },
    {
        "question": "Ninjas fight in an arena with fast and brutal combat.",
        "possibilities": [
            "Nidhogg",
            "Samurai Gunn",
            "TowerFall",
            "Lethal League"
        ],
        "answer": 0
    },
    {
        "question": "Which of these games is NOT a Rogue Like/Lite?",
        "possibilities": [
            "Super Meat Boy",
            "Hades",
            "The Binding of Isaac",
            "Slay the Spire"
        ],
        "answer": 0
    },
    {
        "question": "Which genre asks you to defend a base against waves?",
        "possibilities": [
            "Tower Defense",
            "FPS",
            "Racing",
            "Dating Sim"
        ],
        "answer": 0
    },
    {
        "question": "Which country is considered a massive hub for indie development in Europe?",
        "possibilities": [
            "France",
            "Sweden",
            "Poland",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which FPS is indie?",
        "possibilities": [
            "ULTRAKILL",
            "Call of Duty",
            "Battlefield",
            "Halo"
        ],
        "answer": 0
    },
    {
        "question": "What is the pseudonym of the creator of Minecraft?",
        "possibilities": [
            "Notch",
            "Jeb",
            "Dinnerbone",
            "Herobrine"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play an AI controlling giant mechs on a grid?",
        "possibilities": [
            "Into the Breach",
            "BattleTech",
            "MechWarrior",
            "Titanfall"
        ],
        "answer": 0
    },
    {
        "question": "Adventurers explore randomly generated dungeons with various classes.",
        "possibilities": [
            "Risk of Rain 2",
            "Roboquest",
            "Gunfire Reborn",
            "Wizard of Legend"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Boomer Shooter'?",
        "possibilities": [
            "Retro-style FPS",
            "Game for elderly",
            "Puzzle game",
            "Hunting sim"
        ],
        "answer": 0
    },
    {
        "question": "What art style is used in Cuphead?",
        "possibilities": [
            "1930s cartoon",
            "Pixel art",
            "Watercolor",
            "3D cel-shading"
        ],
        "answer": 0
    },
    {
        "question": "Knights defend a castle against waves of goblins in a hybrid TD game.",
        "possibilities": [
            "Dungeon Defenders",
            "Orcs Must Die",
            "Castle Crashers",
            "Rampart"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: In 'Buckshot Roulette', who do you play against?",
        "possibilities": [
            "The Dealer",
            "Another player",
            "A robot",
            "Yourself"
        ],
        "answer": 0
    },
    {
        "question": "Stats: Which indie game was the most awarded in 2020?",
        "possibilities": [
            "Hades",
            "Spiritfarer",
            "Phasmophobia",
            "Fall Guys"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play an amnesiac detective in a derelict city?",
        "possibilities": [
            "Disco Elysium",
            "Gamedec",
            "Shadows of Doubt",
            "Lacuna"
        ],
        "answer": 0
    },
    {
        "question": "In 'Outer Wilds', how long is the loop before the sun explodes?",
        "possibilities": [
            "22 minutes",
            "10 minutes",
            "60 minutes",
            "5 minutes"
        ],
        "answer": 0
    },
    {
        "question": "Which indie studio built a custom engine for 'Noita' to simulate every pixel?",
        "possibilities": [
            "Nolla Games",
            "Facepunch",
            "Re-Logic",
            "Coffee Stain"
        ],
        "answer": 0
    },
    {
        "question": "What genre is 'Factorio'?",
        "possibilities": [
            "Automation / Factory Sim",
            "RPG",
            "Space Combat",
            "Sports"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game was funded with over $2M on Kickstarter in record time?",
        "possibilities": [
            "Eiyuden Chronicle",
            "Shenmue III",
            "Bloodstained",
            "Pillars of Eternity"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie reached 1 million sales in 24h despite being a poker game?",
        "possibilities": [
            "Balatro",
            "Buckshot Roulette",
            "Stacklands",
            "Poker Night"
        ],
        "answer": 0
    },
    {
        "question": "A knight digs tunnels to find treasures and ore.",
        "possibilities": [
            "SteamWorld Dig",
            "Terraria",
            "Minecraft",
            "Dig Dug"
        ],
        "answer": 0
    },
    {
        "question": "Which rhythm game has you slice colored cubes with laser sabers?",
        "possibilities": [
            "Beat Saber",
            "Audica",
            "Pistol Whip",
            "Synth Riders"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie game mixes creatures with guns?",
        "possibilities": [
            "Palworld",
            "Cassette Beasts",
            "Temtem",
            "Coromon"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a knight on a horse in a 2D kingdom?",
        "possibilities": [
            "Kingdom: Two Crowns",
            "Nidhogg",
            "Blasphemous",
            "Salt and Sanctuary"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a farm on an alien planet?",
        "possibilities": [
            "Slime Rancher",
            "Astroneer",
            "No Man's Sky",
            "My Time at Portia"
        ],
        "answer": 0
    },
    {
        "question": "In 'Papers, Please', what country are you from?",
        "possibilities": [
            "Arstotzka",
            "Kolechia",
            "Obristan",
            "Antegria"
        ],
        "answer": 0
    },
    {
        "question": "Stick figures fight with fluid animations.",
        "possibilities": [
            "Stick Fight: The Game",
            "One Finger Death Punch",
            "Nidhogg",
            "Toribash"
        ],
        "answer": 0
    },
    {
        "question": "Which genre features top-down view and lots of loot?",
        "possibilities": [
            "Hack'n Slash",
            "Visual Novel",
            "Platformer",
            "Battle Royale"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game allows you to play as an Archer, a Wizard, and a Knight simultaneously?",
        "possibilities": [
            "Trine",
            "Fez",
            "Tunic",
            "Celeste"
        ],
        "answer": 0
    },
    {
        "question": "In 'Slay the Spire', which character uses energy orbs?",
        "possibilities": [
            "The Defect",
            "The Ironclad",
            "The Silent",
            "The Watcher"
        ],
        "answer": 0
    },
    {
        "question": "A mystical warrior fights in an infinite tower using a deck.",
        "possibilities": [
            "One Step From Eden",
            "Slay the Spire",
            "Nowhere Prophet",
            "Monster Train"
        ],
        "answer": 0
    },
    {
        "question": "Which of these photography games is indie?",
        "possibilities": [
            "TOEM",
            "Pokémon Snap",
            "Umurangi Generation",
            "Penko Park"
        ],
        "answer": 0
    },
    {
        "question": "Two characters must cooperate to escape a prison by solving puzzles.",
        "possibilities": [
            "We Were Here",
            "Prison Architects",
            "It Takes Two",
            "Portal 2"
        ],
        "answer": 0
    },
    {
        "question": "In 'Subnautica', what is your worst enemy at the start?",
        "possibilities": [
            "Oxygen level",
            "Sharks",
            "Hunger",
            "Thirst"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game is famous for its Black, White, and Red art style?",
        "possibilities": [
            "Othercide",
            "Trek to Yomi",
            "Betrayer",
            "MadWorld"
        ],
        "answer": 0
    },
    {
        "question": "In 'Vampire Survivors', how do you unlock 'Death' as a character?",
        "possibilities": [
            "Kill her at the end of a run",
            "Finish the game",
            "Pay 1M gold",
            "Impossible"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you create complex machines to solve puzzles?",
        "possibilities": [
            "Opus Magnum",
            "Infinifactory",
            "SpaceChem",
            "Baba Is You"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a dog that takes photos?",
        "possibilities": [
            "Pupperazzi",
            "Alba: A Wildlife Adventure",
            "Umurangi Generation",
            "Paradise Killer"
        ],
        "answer": 0
    },
    {
        "question": "How many Golden Strawberries can you collect total in Celeste?",
        "possibilities": [
            "202",
            "175",
            "150",
            "225"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Metroidvania'?",
        "possibilities": [
            "Mix of Metroid and Castlevania",
            "Shooter",
            "Sports game",
            "Card game"
        ],
        "answer": 0
    },
    {
        "question": "In 'Stardew Valley', what is the name of the evil corporation?",
        "possibilities": [
            "Joja Corp",
            "MegaCorp",
            "Evil-Mart",
            "Amazon"
        ],
        "answer": 0
    },
    {
        "question": "A man looks for his missing daughter in a haunted forest.",
        "possibilities": [
            "The Forest",
            "Sons of the Forest",
            "Alan Wake",
            "Blair Witch"
        ],
        "answer": 0
    },
    {
        "question": "In which game must you climb a mountain as Madeline?",
        "possibilities": [
            "Celeste",
            "Getting Over It",
            "Jump King",
            "Jusant"
        ],
        "answer": 0
    },
    {
        "question": "What is the goal of FTL: Faster Than Light?",
        "possibilities": [
            "Cross the galaxy to deliver data",
            "Destroy all enemies",
            "Colonize planets",
            "Save the crew"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a traveling merchant in a fantasy world?",
        "possibilities": [
            "Merchant of the Skies",
            "Moonlighter",
            "Shoppe Keep",
            "Recettear"
        ],
        "answer": 0
    },
    {
        "question": "A pixel art cowboy shoots bandits in the Wild West.",
        "possibilities": [
            "Westerado",
            "Gunscape",
            "Wild Guns",
            "Sunset Riders"
        ],
        "answer": 0
    },
    {
        "question": "What does 'Early Access' on Steam mean?",
        "possibilities": [
            "Buy while in development",
            "Play for free",
            "Pre-order finished game",
            "Special mode"
        ],
        "answer": 0
    },
    {
        "question": "In 'Cult of the Lamb', which animal do you play as?",
        "possibilities": [
            "A lamb",
            "A wolf",
            "A deer",
            "A cat"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game uses forced perspective and optical illusions?",
        "possibilities": [
            "Superliminal",
            "Viewfinder",
            "Monument Valley",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which indie game has you build bridges that often collapse?",
        "possibilities": [
            "Poly Bridge",
            "World of Goo",
            "Besiege",
            "Bridge Constructor"
        ],
        "answer": 0
    },
    {
        "question": "In 'Celeste', what is the name of Madeline's dark self?",
        "possibilities": [
            "Badeline",
            "Shadow Madeline",
            "Dark Madeline",
            "Part of Me"
        ],
        "answer": 0
    },
    {
        "question": "Stats: Roughly how many indie games release monthly on the eShop?",
        "possibilities": [
            "40 to 100",
            "Under 10",
            "Over 500",
            "5"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Sandbox'?",
        "possibilities": [
            "Player creates own goals",
            "Linear game",
            "Beach game",
            "Fighting game"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Dungeon Crawler'?",
        "possibilities": [
            "Exploring dungeons",
            "Car racing",
            "Cooking game",
            "Life sim"
        ],
        "answer": 0
    },
    {
        "question": "What type of game is Slay the Spire?",
        "possibilities": [
            "Roguelike deck-building",
            "Action RPG",
            "Platformer",
            "Puzzle"
        ],
        "answer": 0
    },
    {
        "question": "A young boy explores the memories of his family through an abandoned house.",
        "possibilities": [
            "What Remains of Edith Finch",
            "Gone Home",
            "Firewatch",
            "Dear Esther"
        ],
        "answer": 0
    },
    {
        "question": "Which simulation game is indie?",
        "possibilities": [
            "PowerWash Simulator",
            "Flight Simulator",
            "Farming Simulator",
            "Euro Truck"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you plant seeds that become platforms?",
        "possibilities": [
            "Grow Home",
            "Grow Up",
            "Botanicula",
            "Samorost"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game has you pack/unpack boxes over several years?",
        "possibilities": [
            "Unpacking",
            "Wilmot's Warehouse",
            "Moving Out",
            "Tetris"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you photo dogs for social media?",
        "possibilities": [
            "Pupperazzi",
            "Toem",
            "Alba",
            "Penko Park"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play a bartender serving cocktails in a cyberpunk bar?",
        "possibilities": [
            "VA-11 Hall-A",
            "Coffee Talk",
            "The Red Strings Club",
            "Necrobarista"
        ],
        "answer": 0
    },
    {
        "question": "Which horror game is indie?",
        "possibilities": [
            "Amnesia: The Dark Descent",
            "Resident Evil Village",
            "Dead Space",
            "Alan Wake 2"
        ],
        "answer": 0
    },
    {
        "question": "Which co-op game is indie?",
        "possibilities": [
            "Deep Rock Galactic",
            "Left 4 Dead 2",
            "It Takes Two",
            "Back 4 Blood"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you solve crimes by interviewing suspects in video clips?",
        "possibilities": [
            "Her Story",
            "Telling Lies",
            "Late Shift",
            "The Shapeshifting Detective"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you dive into the ocean to explore wrecks and marine life?",
        "possibilities": [
            "Subnautica",
            "Abzu",
            "Beyond Blue",
            "In Other Waters"
        ],
        "answer": 0
    },
    {
        "question": "Which Open Source engine is gaining massive popularity among indies?",
        "possibilities": [
            "Godot",
            "Unity",
            "Unreal Engine",
            "RPG Maker"
        ],
        "answer": 0
    },
    {
        "question": "In 'Subnautica', what is the name of the crashed ship?",
        "possibilities": [
            "The Aurora",
            "The Odyssey",
            "The Neptune",
            "The Titan"
        ],
        "answer": 0
    },
    {
        "question": "In 'Don't Starve', who is the scientist?",
        "possibilities": [
            "Wilson",
            "Willow",
            "Wolfgang",
            "Wendy"
        ],
        "answer": 0
    },
    {
        "question": "In 'Obra Dinn', what object sees the moment of death?",
        "possibilities": [
            "Memento Mortem watch",
            "Mirror",
            "Book",
            "Compass"
        ],
        "answer": 0
    },
    {
        "question": "Which 'Wrestling' game is indie?",
        "possibilities": [
            "WrestleQuest",
            "WWE 2K24",
            "AEW Fight Forever",
            "Fire Pro Wrestling"
        ],
        "answer": 0
    },
    {
        "question": "Robots fight in an arena with improvised weapons.",
        "possibilities": [
            "Robot Arena",
            "Brawlhalla",
            "Lethal League",
            "BattleBots"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game surpassed 20 million sales thanks to word of mouth and a low price?",
        "possibilities": [
            "Vampire Survivors",
            "Terraria",
            "Stardew Valley",
            "Undertale"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you create potions by mixing ingredients?",
        "possibilities": [
            "Potion Craft",
            "Potionomics",
            "Alchemist's Awakening",
            "Little Alchemist"
        ],
        "answer": 0
    },
    {
        "question": "Which 2024 indie is a PS1-style horror in a zoo?",
        "possibilities": [
            "Crow Country",
            "Zoochosis",
            "Zoonomaly",
            "Critters"
        ],
        "answer": 0
    },
    {
        "question": "Which of these dinosaur games is indie?",
        "possibilities": [
            "Second Extinction",
            "Jurassic World Evolution",
            "ARK",
            "Dino Crisis"
        ],
        "answer": 0
    },
    {
        "question": "Which tower defense game has you place monkeys that throw darts?",
        "possibilities": [
            "Bloons TD",
            "Plants vs Zombies",
            "Kingdom Rush",
            "Defense Grid"
        ],
        "answer": 0
    },
    {
        "question": "In 'Papers, Please', what is your job?",
        "possibilities": [
            "Immigration officer",
            "Police officer",
            "Lawyer",
            "Doctor"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Walking Simulator'?",
        "possibilities": [
            "Exploration and Narrative focus",
            "Sports sim",
            "Racing game",
            "Hiking sim"
        ],
        "answer": 0
    },
    {
        "question": "Which of these is a major indie production?",
        "possibilities": [
            "Vampire Survivors",
            "Diablo IV",
            "Final Fantasy VII Rebirth",
            "Starfield"
        ],
        "answer": 0
    },
    {
        "question": "Approximately how many copies of 'Terraria' have been sold?",
        "possibilities": [
            "Over 44 million",
            "10 million",
            "5 million",
            "100 million"
        ],
        "answer": 0
    },
    {
        "question": "Which narrative game is indie?",
        "possibilities": [
            "Firewatch",
            "Detroit: Become Human",
            "Life is Strange",
            "Heavy Rain"
        ],
        "answer": 0
    },
    {
        "question": "Which deckbuilding game is indie?",
        "possibilities": [
            "Inscryption",
            "Yu-Gi-Oh!",
            "MTG Arena",
            "Hearthstone"
        ],
        "answer": 0
    },
    {
        "question": "A luchador fights in a colorful Mexican-inspired world.",
        "possibilities": [
            "Guacamelee",
            "Brawlhalla",
            "Rivals of Aether",
            "Lethal League"
        ],
        "answer": 0
    },
    {
        "question": "What is 'Procedural Generation'?",
        "possibilities": [
            "Algorithmically created levels",
            "Hand-drawn art",
            "Voice acting",
            "Marketing"
        ],
        "answer": 0
    },
    {
        "question": "Which engine is specialized for Indie Visual Novels?",
        "possibilities": [
            "Ren'Py",
            "RPG Maker",
            "GameMaker",
            "Twine"
        ],
        "answer": 0
    },
    {
        "question": "Which of these mecha games is indie?",
        "possibilities": [
            "Into the Breach",
            "Armored Core VI",
            "Front Mission",
            "Titanfall 2"
        ],
        "answer": 0
    },
    {
        "question": "Winged creatures defend their nest against invaders.",
        "possibilities": [
            "Tooth and Tail",
            "Northgard",
            "They Are Billions",
            "Creeper World"
        ],
        "answer": 0
    },
    {
        "question": "What do you call a game with permanent death and random levels?",
        "possibilities": [
            "Roguelike",
            "Metroidvania",
            "RPG",
            "Simulation"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Cozy Game'?",
        "possibilities": [
            "Relaxing non-violent game",
            "Extreme horror",
            "Intense competition",
            "War game"
        ],
        "answer": 0
    },
    {
        "question": "In 'Road 96', what is the goal of the teenagers?",
        "possibilities": [
            "Cross the border",
            "Win a race",
            "Find parents",
            "Become famous"
        ],
        "answer": 0
    },
    {
        "question": "Which survival game has you manage hunger, thirst, and sanity?",
        "possibilities": [
            "Don't Starve",
            "The Forest",
            "Rust",
            "Green Hell"
        ],
        "answer": 0
    },
    {
        "question": "How long does a single life last in the game Minit?",
        "possibilities": [
            "60 seconds",
            "5 minutes",
            "10 minutes",
            "30 minutes"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game has you guide water towards plants?",
        "possibilities": [
            "Where's My Water",
            "World of Goo",
            "Puddle",
            "Fluidity"
        ],
        "answer": 0
    },
    {
        "question": "Luminous creatures travel together through a mystical desert.",
        "possibilities": [
            "Journey",
            "Abzu",
            "Sky: Children of the Light",
            "Flower"
        ],
        "answer": 0
    },
    {
        "question": "Which mental health struggle does Celeste primarily address?",
        "possibilities": [
            "Anxiety and Depression",
            "OCD",
            "Schizophrenia",
            "PTSD"
        ],
        "answer": 0
    },
    {
        "question": "In 'Outer Wilds', what instrument does the home planet traveler play?",
        "possibilities": [
            "Banjo",
            "Guitar",
            "Harmonica",
            "Flute"
        ],
        "answer": 0
    },
    {
        "question": "Which rhythm game is indie?",
        "possibilities": [
            "Sayonara Wild Hearts",
            "Guitar Hero",
            "Just Dance",
            "Rock Band"
        ],
        "answer": 0
    },
    {
        "question": "Which of these fishing games is indie?",
        "possibilities": [
            "Dredge",
            "Sega Bass Fishing",
            "Fishing Planet",
            "Bassmaster"
        ],
        "answer": 0
    },
    {
        "question": "Which of these sniper games is indie?",
        "possibilities": [
            "Children of the Sun",
            "Sniper Elite 5",
            "Sniper Ghost Warrior",
            "Hitman Sniper"
        ],
        "answer": 0
    },
    {
        "question": "Medieval heroes defend their kingdom against monster hordes.",
        "possibilities": [
            "Dungeon Defenders",
            "Orcs Must Die",
            "Castle Crashers",
            "For The King"
        ],
        "answer": 0
    },
    {
        "question": "On which planet does Subnautica take place?",
        "possibilities": [
            "4546B",
            "LV-426",
            "Pandora",
            "Reach"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play a god creating life on a planet?",
        "possibilities": [
            "Reus",
            "From Dust",
            "Godus",
            "Birthdays the Beginning"
        ],
        "answer": 0
    },
    {
        "question": "Among these tavern management games, which is indie?",
        "possibilities": [
            "Travellers Rest",
            "Tavern Master",
            "Crossroads Inn",
            "Ale & Tale"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game mixes shopkeeping by day and dungeon exploration by night?",
        "possibilities": [
            "Moonlighter",
            "Stardew Valley",
            "Graveyard Keeper",
            "My Time at Portia"
        ],
        "answer": 0
    },
    {
        "question": "What happens if you finish Undertale without killing anyone?",
        "possibilities": [
            "You get the Pacifist ending",
            "The game restarts",
            "You unlock a secret boss",
            "Nothing special"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game parodies 80s/90s action movies?",
        "possibilities": [
            "Broforce",
            "Hotline Miami",
            "Huntdown",
            "My Friend Pedro"
        ],
        "answer": 0
    },
    {
        "question": "Which studio created 'Don't Starve' and 'Oxygen Not Included'?",
        "possibilities": [
            "Klei Entertainment",
            "Supergiant Games",
            "Chucklefish",
            "Tynan Sylvester"
        ],
        "answer": 0
    },
    {
        "question": "Which genre focuses on solving logic riddles?",
        "possibilities": [
            "Puzzle Game",
            "Hack'n Slash",
            "Point & Click",
            "Racing"
        ],
        "answer": 0
    },
    {
        "question": "Which rhythm game has you descend into a dungeon following the beat?",
        "possibilities": [
            "Crypt of the NecroDancer",
            "BPM: Bullets Per Minute",
            "Beat Saber",
            "Thumper"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: Which 2023 indie has you play as a small robot in a puzzle world?",
        "possibilities": [
            "Cocoon",
            "Animal Well",
            "Hauntii",
            "Selaco"
        ],
        "answer": 0
    },
    {
        "question": "In 'Tunic', what classic game item does the fox wear?",
        "possibilities": [
            "Green tunic",
            "Red hat",
            "Seven-league boots",
            "Cape"
        ],
        "answer": 0
    },
    {
        "question": "In 'Terraria', what item allows permanent flight at end-game?",
        "possibilities": [
            "UFO Mount",
            "Wings",
            "Jetpack",
            "Jump Boots"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game takes place entirely on a fictional computer screen?",
        "possibilities": [
            "Hypnospace Outlaw",
            "Her Story",
            "Emily is Away",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which indie focuses on deciphering forgotten languages?",
        "possibilities": [
            "Chants of Sennaar",
            "Heaven's Vault",
            "Sethian",
            "7 Days"
        ],
        "answer": 0
    },
    {
        "question": "Which open world game is indie?",
        "possibilities": [
            "Sable",
            "Cyberpunk 2077",
            "Elden Ring",
            "Ghost of Tsushima"
        ],
        "answer": 0
    },
    {
        "question": "Which detective game is indie?",
        "possibilities": [
            "Return of the Obra Dinn",
            "L.A. Noire",
            "Sherlock Holmes",
            "Cluedo"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was inspired by artist Zdzisław Beksiński?",
        "possibilities": [
            "Scorn",
            "Darkwood",
            "Blasphemous",
            "The Medium"
        ],
        "answer": 0
    },
    {
        "question": "Which game is a coop game where you have to solve puzzles to destroy a tower destroying time and space ?",
        "possibilities": [
            "Time Handlers",
            "We Were Here",
            "It Takes Two",
            "Escape Academy"
        ],
        "answer": 0
    },
    {
        "question": "What is special about the dialogue in Hyper Light Drifter?",
        "possibilities": [
            "No text, only images",
            "Foreign language",
            "Sung dialogue",
            "No dialogue at all"
        ],
        "answer": 0
    },
    {
        "question": "Which is an indie Metroidvania?",
        "possibilities": [
            "Blasphemous",
            "Metroid Dread",
            "Prince of Persia",
            "Castlevania"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game was developed by a former NASA engineer?",
        "possibilities": [
            "Kerbal Space Program",
            "Astroneer",
            "Outer Wilds",
            "Oxygen Not Included"
        ],
        "answer": 0
    },
    {
        "question": "In 'Dead Cells', what is the protagonist called?",
        "possibilities": [
            "The Beheaded",
            "The Prisoner",
            "The Knight",
            "The Mutant"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Platformer'?",
        "possibilities": [
            "Jumping between platforms",
            "Card game",
            "Management",
            "Dance game"
        ],
        "answer": 0
    },
    {
        "question": "A knight explores a procedurally generated world with various biomes.",
        "possibilities": [
            "Terraria",
            "Starbound",
            "Edge of Space",
            "Crea"
        ],
        "answer": 0
    },
    {
        "question": "How many games on average were released on Steam per day in 2023?",
        "possibilities": [
            "Over 35",
            "5",
            "100",
            "15"
        ],
        "answer": 0
    },
    {
        "question": "What year was 'Minecraft' officially released in version 1.0?",
        "possibilities": [
            "2011",
            "2009",
            "2013",
            "2010"
        ],
        "answer": 0
    },
    {
        "question": "In 'Jusant', what small animal helps you climb?",
        "possibilities": [
            "The Ballast",
            "A lizard",
            "A bird",
            "A monkey"
        ],
        "answer": 0
    },
    {
        "question": "A young girl explores a colorful world to find her voice and emotions.",
        "possibilities": [
            "Gris",
            "Journey",
            "Abzu",
            "Flower"
        ],
        "answer": 0
    },
    {
        "question": "Which of these card games is indie?",
        "possibilities": [
            "Balatro",
            "Marvel Snap",
            "Gwent",
            "Hearthstone"
        ],
        "answer": 0
    },
    {
        "question": "Which genre defines 'Stardew Valley'?",
        "possibilities": [
            "Farming Sim / Life Sim",
            "Roguelike",
            "FPS",
            "Horror"
        ],
        "answer": 0
    },
    {
        "question": "A robot explores an abandoned factory to discover its past.",
        "possibilities": [
            "Machinarium",
            "Primordia",
            "Botanicula",
            "The Silent Age"
        ],
        "answer": 0
    },
    {
        "question": "Which genre is 'Disco Elysium'?",
        "possibilities": [
            "Narrative RPG",
            "FPS",
            "Racing",
            "Puzzle"
        ],
        "answer": 0
    },
    {
        "question": "What colors are mainly used in the game Limbo?",
        "possibilities": [
            "Black and White",
            "Blue and Gray",
            "Red and Black",
            "Green and Brown"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a colony in space with randomly generated characters?",
        "possibilities": [
            "RimWorld",
            "Dwarf Fortress",
            "Oxygen Not Included",
            "Space Haven"
        ],
        "answer": 0
    },
    {
        "question": "In 'Balatro', what does the 'Gros Michel' Joker do?",
        "possibilities": [
            "Gives Mult then can go extinct",
            "Gives money",
            "Gives chips",
            "Buffs Bananas"
        ],
        "answer": 0
    },
    {
        "question": "What is a 'Visual Novel'?",
        "possibilities": [
            "Interactive book with choices",
            "Action game",
            "Flight sim",
            "Fighting game"
        ],
        "answer": 0
    },
    {
        "question": "In 'Vampire Survivors', what is the main goal?",
        "possibilities": [
            "Survive 30 minutes",
            "Kill Dracula",
            "Build a castle",
            "Save a princess"
        ],
        "answer": 0
    },
    {
        "question": "Which game popularized 'Walking Simulator' as a term?",
        "possibilities": [
            "Dear Esther",
            "Firewatch",
            "Gone Home",
            "Proteus"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a hospital with wacky diseases?",
        "possibilities": [
            "Two Point Hospital",
            "Theme Hospital",
            "Hospital Tycoon",
            "Project Hospital"
        ],
        "answer": 0
    },
    {
        "question": "Which of these is a 2024 indie success?",
        "possibilities": [
            "Manor Lords",
            "Dragon's Dogma 2",
            "Tekken 8",
            "Helldivers 2"
        ],
        "answer": 0
    },
    {
        "question": "In 'Firewatch', what is your main communication tool?",
        "possibilities": [
            "Walkie-talkie",
            "Mobile phone",
            "Smoke signals",
            "Letters"
        ],
        "answer": 0
    },
    {
        "question": "A man climbs a mountain using only a hammer while stuck in a pot.",
        "possibilities": [
            "Getting Over It with Bennett Foddy",
            "Jump King",
            "Pogostuck",
            "I Am Bread"
        ],
        "answer": 0
    },
    {
        "question": "Which of these skateboard games is indie?",
        "possibilities": [
            "Session: Skate Sim",
            "Tony Hawk Pro Skater",
            "Skate 3",
            "OlliOlli"
        ],
        "answer": 3
    },
    {
        "question": "Which game features a cleric fighting demons with divine spells in a pixel-art world?",
        "possibilities": [
            "Blasphemous",
            "Eldest Souls",
            "Death's Gambit",
            "Ender Lilies"
        ],
        "answer": 0
    },
    {
        "question": "A small yarn creature goes on an adventure and meets another yarn creature.",
        "possibilities": [
            "Unravel",
            "Cuphead",
            "Hollow Knight",
            "It Takes Two"
        ],
        "answer": 0
    },
    {
        "question": "What does 'Soulslike' refer to?",
        "possibilities": [
            "High difficulty and loss of progress",
            "Easy mode",
            "Luck based",
            "Multiplayer only"
        ],
        "answer": 0
    },
    {
        "question": "In 'Inscryption', which animal is your first card companion?",
        "possibilities": [
            "Stoat",
            "Wolf",
            "Frog",
            "Squirrel"
        ],
        "answer": 0
    },
    {
        "question": "Which of these games is actually independent?",
        "possibilities": [
            "Outer Wilds",
            "Starfield",
            "Destiny 2",
            "Assassin's Creed"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a 'Medieval Cemetery Manager'?",
        "possibilities": [
            "Graveyard Keeper",
            "Medieval Dynasty",
            "Banished",
            "Going Medieval"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage an amusement park with roller coasters?",
        "possibilities": [
            "Parkitect",
            "RollerCoaster Tycoon",
            "Planet Coaster",
            "Theme Park Studio"
        ],
        "answer": 0
    },
    {
        "question": "In 'Terraria', what is the first boss most players face?",
        "possibilities": [
            "Eye of Cthulhu",
            "Wall of Flesh",
            "Skeletron",
            "Plantera"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was removed from stores because it was 'too addictive'?",
        "possibilities": [
            "Flappy Bird",
            "2048",
            "Threes",
            "Temple Run"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a stray cat in a cyberpunk city?",
        "possibilities": [
            "Stray",
            "Cat Quest",
            "Night in the Woods",
            "A Cat's Tale"
        ],
        "answer": 0
    },
    {
        "question": "Viking warriors defend their village against mythological creatures.",
        "possibilities": [
            "Tribes of Midgard",
            "Valheim",
            "Jotun",
            "Rune"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game mixes golf with randomness (e.g., a house, a car)?",
        "possibilities": [
            "What the Golf?",
            "Golf With Your Friends",
            "Golf Story",
            "Turbo Golf Racing"
        ],
        "answer": 0
    },
    {
        "question": "A knight explores a kingdom with a hereditary permanent death mechanic.",
        "possibilities": [
            "Rogue Legacy",
            "Dead Cells",
            "Wizard of Legend",
            "Children of Morta"
        ],
        "answer": 0
    },
    {
        "question": "Which French studio developed the cat game 'Stray'?",
        "possibilities": [
            "BlueTwelve Studio",
            "Motion Twin",
            "Sloclap",
            "Arkane"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: In 'Katana ZERO', what does the drug 'Chronos' do?",
        "possibilities": [
            "Slow down time",
            "Invisibility",
            "Flight",
            "Fire breath"
        ],
        "answer": 0
    },
    {
        "question": "Which French studio created Dead Cells?",
        "possibilities": [
            "Motion Twin",
            "Team Cherry",
            "Supergiant Games",
            "Thunder Lotus"
        ],
        "answer": 0
    },
    {
        "question": "Which puzzle game with liquids is indie?",
        "possibilities": [
            "World of Goo",
            "Puddle",
            "Where's My Water?",
            "Liquid War"
        ],
        "answer": 0
    },
    {
        "question": "Which platform is the go-to for experimental or free indie games?",
        "possibilities": [
            "Itch.io",
            "Steam",
            "GameJolt",
            "Epic Games"
        ],
        "answer": 0
    },
    {
        "question": "In 'Stardew Valley', what is the name of the town?",
        "possibilities": [
            "Pelican Town",
            "Sunflower Town",
            "River City",
            "Oak Village"
        ],
        "answer": 0
    },
    {
        "question": "Which genre asks you to manage resources and build a base?",
        "possibilities": [
            "Management / City Builder",
            "FPS",
            "Beat'em All",
            "Visual Novel"
        ],
        "answer": 0
    },
    {
        "question": "Cute creatures build cities and explore in a colorful world.",
        "possibilities": [
            "Slime Rancher",
            "Bugsnax",
            "Ooblets",
            "Garden Paws"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was developed by one person for 7 years?",
        "possibilities": [
            "Stardew Valley",
            "Cave Story",
            "Axiom Verge",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which sub service includes many indies 'Day One'?",
        "possibilities": [
            "Xbox Game Pass",
            "PS Plus",
            "Indie Pass",
            "Steam Deck"
        ],
        "answer": 0
    },
    {
        "question": "How much did Microsoft pay to buy Minecraft in 2014?",
        "possibilities": [
            "$2.5 billion",
            "1 euro",
            "$150 million",
            "$1 billion"
        ],
        "answer": 0
    },
    {
        "question": "In 'Animal Well', what animal do you play as?",
        "possibilities": [
            "A small blob creature",
            "A rabbit",
            "A cat",
            "A bird"
        ],
        "answer": 0
    },
    {
        "question": "What percentage of games released on Steam in 2023 were indie?",
        "possibilities": [
            "Over 95%",
            "50%",
            "20%",
            "Under 10%"
        ],
        "answer": 0
    },
    {
        "question": "Which game engine is most used by indie developers on Steam?",
        "possibilities": [
            "Unity",
            "Unreal Engine",
            "Godot",
            "GameMaker"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you create words to change the environment?",
        "possibilities": [
            "Baba Is You",
            "Scribblenauts",
            "Typoman",
            "Letter Quest"
        ],
        "answer": 0
    },
    {
        "question": "Which construction game is indie?",
        "possibilities": [
            "Townscaper",
            "The Sims 4",
            "SimCity",
            "Zoo Tycoon"
        ],
        "answer": 0
    },
    {
        "question": "Anthropomorphic rabbits explore a post-apocalyptic world.",
        "possibilities": [
            "Overgrowth",
            "Dust: An Elysian Tail",
            "Stories: The Path of Destinies",
            "Armello"
        ],
        "answer": 0
    },
    {
        "question": "Which indie platformer is famous for extreme difficulty and a character made of meat?",
        "possibilities": [
            "Super Meat Boy",
            "Celeste",
            "Cuphead",
            "Shovel Knight"
        ],
        "answer": 0
    },
    {
        "question": "Which 2012 indie proved that 'Walking Sim' games could succeed?",
        "possibilities": [
            "Dear Esther",
            "Gone Home",
            "Firewatch",
            "Stanley Parable"
        ],
        "answer": 0
    },
    {
        "question": "Which annual GDC event rewards independent games?",
        "possibilities": [
            "IGF",
            "The Game Awards",
            "BAFTA",
            "DICE"
        ],
        "answer": 0
    },
    {
        "question": "In 'Dredge', what is your profession?",
        "possibilities": [
            "Fisherman",
            "Hunter",
            "Miner",
            "Diver"
        ],
        "answer": 0
    },
    {
        "question": "What is the average price of an indie game on Steam?",
        "possibilities": [
            "$5 - $15",
            "Under $2",
            "Over $30",
            "Free"
        ],
        "answer": 0
    },
    {
        "question": "What is 'Point & Click'?",
        "possibilities": [
            "Mouse-based adventure game",
            "FPS",
            "Racing game",
            "Fighting game"
        ],
        "answer": 0
    },
    {
        "question": "In 'A Short Hike', what is the bird's goal?",
        "possibilities": [
            "Get phone reception",
            "Find treasure",
            "Learn to fly",
            "Take a photo"
        ],
        "answer": 0
    },
    {
        "question": "Which action game is indie?",
        "possibilities": [
            "Hades",
            "Devil May Cry 5",
            "God of War",
            "Bayonetta 3"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play a 'Plague Doctor'?",
        "possibilities": [
            "Thymesia",
            "Plague Inc",
            "Darkest Dungeon",
            "Potion Permit"
        ],
        "answer": 0
    },
    {
        "question": "What term refers to a small studio with low budget?",
        "possibilities": [
            "Independent (Indie)",
            "Major",
            "AAA",
            "Publisher"
        ],
        "answer": 0
    },
    {
        "question": "In 'Dredge', what happens if you panic too much at night?",
        "possibilities": [
            "Hallucinations and monsters appear",
            "More money",
            "Faster boat",
            "Nothing"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a tower of mages with deck-building mechanics?",
        "possibilities": [
            "Inscryption",
            "Monster Train",
            "Slay the Spire",
            "Roguebook"
        ],
        "answer": 0
    },
    {
        "question": "In 'The Stanley Parable', who comments on all your actions?",
        "possibilities": [
            "The Narrator",
            "Your boss",
            "Your wife",
            "A robot"
        ],
        "answer": 0
    },
    {
        "question": "What is the main weapon of the hero in Shovel Knight?",
        "possibilities": [
            "A shovel",
            "A sword",
            "A hammer",
            "A spear"
        ],
        "answer": 0
    },
    {
        "question": "Which card game has you fight with anthropomorphic animals for a throne?",
        "possibilities": [
            "Armello",
            "Inscryption",
            "Slay the Spire",
            "Dicey Dungeons"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is famous for music by Darren Korb?",
        "possibilities": [
            "Hades",
            "Celeste",
            "Journey",
            "Undertale"
        ],
        "answer": 0
    },
    {
        "question": "How many people made up the core team of 'Valheim' at release?",
        "possibilities": [
            "5 people",
            "50 people",
            "1 person",
            "100 people"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: Which 2024 indie uses an ultra-realistic 'Bodycam' style?",
        "possibilities": [
            "Bodycam",
            "Unrecord",
            "Exit 8",
            "Pools"
        ],
        "answer": 0
    },
    {
        "question": "Which indie was the first to win a Hugo Award (literary prize)?",
        "possibilities": [
            "Hades",
            "Disco Elysium",
            "Outer Wilds",
            "Undertale"
        ],
        "answer": 0
    },
    {
        "question": "A man explores his own memory to discover the truth.",
        "possibilities": [
            "To the Moon",
            "Finding Paradise",
            "A Bird Story",
            "The Beginner's Guide"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is a complex underground colony simulation?",
        "possibilities": [
            "Oxygen Not Included",
            "RimWorld",
            "Fallout Shelter",
            "Dig or Die"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you salvage spaceships to pay a debt?",
        "possibilities": [
            "Hardspace: Shipbreaker",
            "Star Citizen",
            "Elite Dangerous",
            "Space Engineers"
        ],
        "answer": 0
    },
    {
        "question": "Which game is a versus game on a board where the main mechanic is based on retroactivity ?",
        "possibilities": [
            "RetroFight",
            "Retro Bowl",
            "Strategy of Time",
            "Terraria"
        ],
        "answer": 0
    },
    {
        "question": "Pirates sail the seas looking for treasures in a top-down view.",
        "possibilities": [
            "Windward",
            "Blackwake",
            "Pirate Den",
            "Sea of Thieves"
        ],
        "answer": 0
    },
    {
        "question": "In 'The Binding of Isaac', what is Isaac's main weapon?",
        "possibilities": [
            "Tears",
            "Sword",
            "Blood",
            "Bombs"
        ],
        "answer": 0
    },
    {
        "question": "In 'Phasmophobia', which object talks to ghosts?",
        "possibilities": [
            "Spirit Box",
            "Thermometer",
            "UV Light",
            "Ghost Book"
        ],
        "answer": 0
    },
    {
        "question": "Which indie uses real actors (FMV) and was a huge hit on Steam?",
        "possibilities": [
            "Her Story",
            "Immortality",
            "Telling Lies",
            "All of these"
        ],
        "answer": 3
    },
    {
        "question": "Which indie game features a parodic cycling team?",
        "possibilities": [
            "Chariot",
            "Duck Game",
            "Full Ace Tennis",
            "PCM"
        ],
        "answer": 0
    },
    {
        "question": "Which of these 'Survivors-like' games is indie?",
        "possibilities": [
            "Brotato",
            "The Last of Us",
            "Army of Ruin",
            "Soulstone Survivors"
        ],
        "answer": 0
    },
    {
        "question": "Which of these text adventures is indie?",
        "possibilities": [
            "80 Days",
            "Zork",
            "Colossal Cave",
            "Detroit"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you cook dishes with ingredients falling from the sky?",
        "possibilities": [
            "Battle Chef Brigade",
            "Overcooked",
            "Cook Serve Delicious",
            "Cooking Mama"
        ],
        "answer": 0
    },
    {
        "question": "Children explore a mysterious island with supernatural powers.",
        "possibilities": [
            "Oxenfree",
            "Life is Strange",
            "Night in the Woods",
            "Firewatch"
        ],
        "answer": 0
    },
    {
        "question": "What is the best-selling indie game of all time (before its buyout)?",
        "possibilities": [
            "Minecraft",
            "Terraria",
            "Stardew Valley",
            "Garry's Mod"
        ],
        "answer": 0
    },
    {
        "question": "What term refers to a game made by one person?",
        "possibilities": [
            "Solo-dev",
            "AAA",
            "Indie-studio",
            "Outsourcing"
        ],
        "answer": 0
    },
    {
        "question": "Who is 'Lucas Pope'?",
        "possibilities": [
            "Creator of Papers Please",
            "Creator of Fez",
            "Creator of Braid",
            "Creator of Spelunky"
        ],
        "answer": 0
    },
    {
        "question": "A child flees a haunted manor filled with deadly traps.",
        "possibilities": [
            "Little Nightmares",
            "Inside",
            "Limbo",
            "Among the Sleep"
        ],
        "answer": 0
    },
    {
        "question": "Which alchemy game is indie?",
        "possibilities": [
            "Potion Craft",
            "Potionomics",
            "Alchemy Garden",
            "Strange Horticulture"
        ],
        "answer": 0
    },
    {
        "question": "Which indie is 'Minecraft' mixed with 'Tower Defense'?",
        "possibilities": [
            "7 Days to Die",
            "Colony Survival",
            "PixARK",
            "Block n Load"
        ],
        "answer": 0
    },
    {
        "question": "A detective solves crimes in an art deco city in the 1920s.",
        "possibilities": [
            "Paradise Killer",
            "L.A. Noire",
            "Disco Elysium",
            "The Wolf Among Us"
        ],
        "answer": 0
    },
    {
        "question": "Which of these golf games is independent?",
        "possibilities": [
            "Golf Story",
            "PGA Tour 2K23",
            "EA Sports PGA",
            "Mario Golf"
        ],
        "answer": 0
    },
    {
        "question": "Jeu: Which indie is a love letter to JRPGs like Chrono Trigger?",
        "possibilities": [
            "Sea of Stars",
            "Chained Echoes",
            "Ikenfell",
            "Cris Tales"
        ],
        "answer": 0
    },
    {
        "question": "In 'Enter the Gungeon', what is the currency called?",
        "possibilities": [
            "Casings",
            "Coins",
            "Gold Bullets",
            "Credits"
        ],
        "answer": 0
    },
    {
        "question": "Genre: What is a 'Dating Sim'?",
        "possibilities": [
            "Relationship simulator",
            "Data sim",
            "Racing game",
            "Fishing game"
        ],
        "answer": 0
    },
    {
        "question": "Which management game has you run an airline company?",
        "possibilities": [
            "SimAirport",
            "Airport CEO",
            "Sky Haven",
            "Airlines Manager"
        ],
        "answer": 0
    },
    {
        "question": "Which platformer is indie?",
        "possibilities": [
            "Celeste",
            "Rayman Legends",
            "Super Mario Odyssey",
            "Sonic Mania"
        ],
        "answer": 0
    },
    {
        "question": "How long is a full day cycle in Don't Starve?",
        "possibilities": [
            "8 minutes",
            "5 minutes",
            "10 minutes",
            "15 minutes"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you manage a café for spirits in a ghost town?",
        "possibilities": [
            "Necrobarista",
            "Spiritfarer",
            "Coffee Talk",
            "VA-11 Hall-A"
        ],
        "answer": 0
    },
    {
        "question": "Which game has you play as a hole in the ground that swallows objects?",
        "possibilities": [
            "Donut County",
            "Tasty Planet",
            "The Wonderful End of the World",
            "Katamari"
        ],
        "answer": 0
    },
    {
        "question": "Adorable creatures collect resources in a colony sim (inspired by ants/Pikmin).",
        "possibilities": [
            "Grounded",
            "It Takes Two",
            "Pikmin",
            "Bug Fables"
        ],
        "answer": 0
    },
    {
        "question": "Which genre is 'Phasmophobia'?",
        "possibilities": [
            "Co-op Horror",
            "Racing",
            "Card game",
            "Flight sim"
        ],
        "answer": 0
    },
    {
        "question": "Which 2013 indie was an early Early Access hit on Steam?",
        "possibilities": [
            "Prison Architect",
            "DayZ",
            "Starbound",
            "Kerbal Space Program"
        ],
        "answer": 0
    },
    {
        "question": "Which Viking survival game sold over 10 million copies in 2021?",
        "possibilities": [
            "Valheim",
            "The Forest",
            "Rust",
            "ARK"
        ],
        "answer": 0
    },
    {
        "question": "Which of these train games is indie?",
        "possibilities": [
            "Unrailed!",
            "Train Sim World",
            "Train Simulator",
            "Railway Empire"
        ],
        "answer": 0
    },
    {
        "question": "In 'Katana ZERO', what is the hero's favorite item?",
        "possibilities": [
            "Hot Tea",
            "His sword",
            "Cassette player",
            "Bathrobe"
        ],
        "answer": 0
    },
    {
        "question": "Which indie has you play as a detective in a procedural city?",
        "possibilities": [
            "Shadows of Doubt",
            "Disco Elysium",
            "Gamedec",
            "Observer"
        ],
        "answer": 0
    },
    {
        "question": "Which indie game was the most played on Steam Deck in 2023?",
        "possibilities": [
            "Vampire Survivors",
            "Elden Ring",
            "Baldur's Gate 3",
            "Stardew Valley"
        ],
        "answer": 0
    }
];
